import React from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import type { SimpleDataTableProps } from './types';

/**
 * Simple data table component with sticky header.
 * Uses named export to match codebase conventions.
 */
export const SimpleDataTable: React.FC<SimpleDataTableProps> = ({ title, columns, rows, maxHeight = 320 }) => {
  return (
    <Box role="region" aria-label={title}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }} component="h3">
        {title}
      </Typography>
      {rows.length === 0 ? (
        <Typography variant="body2" color="text.secondary" role="status">
          No data available.
        </Typography>
      ) : (
        <TableContainer 
          component={Paper} 
          variant="outlined" 
          sx={{ maxHeight }}
          role="table"
          aria-label={`${title} data table`}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {columns.map((col) => (
                  <TableCell 
                    key={col} 
                    sx={{ fontWeight: 700, bgcolor: 'grey.100' }}
                  >
                    {col}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, rowIndex) => (
                <TableRow key={`${row[columns[0]]}-${rowIndex}`} hover>
                  {columns.map((col) => (
                    <TableCell key={col}>{row[col]}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};
